import {
  AuthRegisterAgentUrl
} from '../utils/agentUrls'
import {
  genericPostRequestToApi
} from '../utils/genericRequests'

/**
 * Register agent
 * @param {Object} data - agent form data (email, name, phone)
 */

const registerAgentRequest = (data) => {
  return genericPostRequestToApi(AuthRegisterAgentUrl(), data)
}

export {
  registerAgentRequest
}
